module.exports = {
	folder_logos : "logos",
	color_n : "#121212",
	color 	: "white",
	ext_bg  : "png", // | png | svg
	ext_mark : "png",
}; 